import { useContext } from "react";
import { Spinner } from "react-bootstrap";
import { FiDownload, FiAlertCircle } from "react-icons/fi";

import { DownloadContext } from "../../data_layer/context/Download/DownloadContext";
import './DownloadStatusBar.css';

export const DownloadStatusBar = () => {
    const { isDownloading, progress, error } = useContext(DownloadContext);

    if (!isDownloading && !error) return null;

    const { feedingsCompleted, feedingsTotal, patientsCompleted, patientsTotal, currentPatient } = progress;
    const percentage = feedingsTotal > 0 ? Math.round((feedingsCompleted / feedingsTotal) * 100) : 0;
    const remaining = feedingsTotal - feedingsCompleted;

    return (
        <div className="download-status-bar">
            <div className="download-status-header">
                {error
                    ? <FiAlertCircle size={16} className="download-icon-error" />
                    : <Spinner animation="border" size="sm" className="download-spinner" />
                }
                <span className="download-status-title">
                    {error ? 'Download failed' : 'Preparing download...'}
                </span>
            </div>

            {error && (
                <span className="download-status-error">{error}</span>
            )}

            {!error && (
                <>
                    {currentPatient && (
                        <span className="download-status-patient">{currentPatient}</span>
                    )}

                    <div className="download-status-counts">
                        {patientsTotal > 0 && (
                            <span>Patient {patientsCompleted} of {patientsTotal}</span>
                        )}
                    </div>

                    <div className="download-status-counts">
                        {feedingsTotal > 0 && (
                            <span>Total feedings: {feedingsTotal}</span>
                        )}
                        {feedingsTotal > 0 && (
                            <span>{remaining} feeding{remaining !== 1 ? 's' : ''} remaining</span>
                        )}
                    </div>

                    <div className="download-progress-track">
                        <div
                            className="download-progress-fill"
                            style={{ width: `${percentage}%` }}
                        />
                    </div>

                    {feedingsTotal > 0 && (
                        <span className="download-status-percentage">{percentage}%</span>
                    )}
                </>
            )}
        </div>
    );
};
